export enum StorageKeys {
  ROOT = 'networking',
  LOGIN = 'networking-login',
  ASSIGNMENT = 'assignment-ids',
  TABLE_NAME = 'networking-table',
  USER = 'user',
}
